/* eslint-disable no-magic-numbers */
/* eslint-disable max-statements */
import React, { useEffect, useState } from "react";
import styles from "./styles.css";
import Search from "../../shared/search";
import InputMobile from "../../shared/input-mobile";
import Button from "../../shared/button";
import getSelectOptions from "../../../utils/helpers/get-select-options";
import { ERR_TYPES, getErrorWithType, unsetErrorType, ERR_MOBILE } from "./selectors";
import { mobileNumberValidator } from "../../../utils/validators/mobile-number-validator";
import PropTypes from "prop-types";

const getTranslatedValue = ({ identifier, key, defaultValue }) => {
    if (identifier) return identifier[key];
    else return defaultValue;
};

const updateRemountedValues = ({ value, fn }) => {
    if (value < 0) fn(Math.abs(value));
    else fn(-value);
};

const ErrorStrip = ({ type, err }) => {
    return (
        err[type] ?
            <span>
                {err[type].errorMessage}
            </span> : null
    );
};

const LegacyForm = ({
    history,
    token,
    mobile,
    brands,
    models,
    leadSource,
    years,
    variants,
    states,
    selectedBrand,
    selectedModel,
    selectedYear,
    selectedVariant,
    selectedState,
    lastUpdatedBrand,
    lastUpdatedModel,
    lastUpdatedYear,
    fetchBrandsConnect,
    fetchModelsConnect,
    fetchYearsConnect,
    fetchVariantsConnect,
    fetchRegistrationStateConnect,
    updateSelectedBrandConnect,
    updateSelectedModelConnect,
    updateSelectedYearConnect,
    updateSelectedVariantConnect,
    updateSelectedStateConnect,
    setMobileConnect,
    updateLeadConnect,
    makeLeadConnect
}) => {

    const [brandRemountValue, setBrandRemountValue] = useState(1);
    const [modelRemountValue, setModelRemountValue] = useState(2);
    const [yearRemountValue, setYearRemountValue] = useState(3);
    const [variantRemountValue, setVariantRemountValue] = useState(4);
    const [stateRemountValue, setStateRemountValue] = useState(5);
    const [error, setError] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    /**
     * fetch brand and state list
     */
    useEffect(() => {
        fetchBrandsConnect();
        fetchRegistrationStateConnect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * fetch models list after brand has been selected
     * remount the model, year and variant search boxes
     */
    useEffect(() => {
        if (lastUpdatedBrand) {
            fetchModelsConnect(selectedBrand.value);
            updateRemountedValues({
                value: modelRemountValue,
                fn: setModelRemountValue
            });
            updateRemountedValues({
                value: yearRemountValue,
                fn: setYearRemountValue
            });
            updateRemountedValues({
                value: variantRemountValue,
                fn: setVariantRemountValue
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lastUpdatedBrand]);

    /**
     * fetch years list after model has been selected
     * remount the year and variant search boxes
     */
    useEffect(() => {
        if (lastUpdatedModel) {
            fetchYearsConnect(selectedModel.value);
            updateRemountedValues({
                value: yearRemountValue,
                fn: setYearRemountValue
            });
            updateRemountedValues({
                value: variantRemountValue,
                fn: setVariantRemountValue
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lastUpdatedModel]);

    useEffect(() => {
        if (lastUpdatedYear) {
            fetchVariantsConnect({
                modelId: selectedModel.value,
                year: selectedYear.label
            });
            updateRemountedValues({
                value: variantRemountValue,
                fn: setVariantRemountValue
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lastUpdatedYear]);

    const onBrandSelection = (data) => {
        updateSelectedBrandConnect(data);
        setError(unsetErrorType({ error, type: ERR_TYPES.BRAND }));
    };

    const onModelSelection = (data) => {
        updateSelectedModelConnect(data);
        setError(unsetErrorType({ error, type: ERR_TYPES.MODEL }));
    };

    const onYearSelection = (data) => {
        updateSelectedYearConnect(data);
        setError(unsetErrorType({ error, type: ERR_TYPES.YEAR }));
    };

    const onVariantSelection = (data) => {
        updateSelectedVariantConnect(data);
        setError(unsetErrorType({ error, type: ERR_TYPES.VARIANT }));
    };

    const onStateSelection = (data) => {
        updateSelectedStateConnect(data);
        setError(unsetErrorType({ error, type: ERR_TYPES.STATE }));
    };

    const onSubmit = () => {
        let isError = false;
        let errorOb = {};
        const variablesToCheck = [
            { key: selectedBrand, type: ERR_TYPES.BRAND },
            { key: selectedModel, type: ERR_TYPES.MODEL },
            { key: selectedYear, type: ERR_TYPES.YEAR },
            { key: selectedVariant, type: ERR_TYPES.VARIANT },
            { key: selectedState, type: ERR_TYPES.STATE },
            {
                key: mobile,
                type: ERR_TYPES.MOBILE,
                customValidator: true,
                validator: mobileNumberValidator,
                getErrorMessage: () => mobile.length ? "Invalid Mobile" : ERR_MOBILE.errorMessage
            }
        ];
        variablesToCheck.forEach((item) => {
            let isKeyError = false;
            /**
            * if custom validator flag is present then
            * validate using the validator present in the object
            * or by default check falsy condition of the variable
            */
            if ((item.customValidator &&
                !item.validator(item.key)) || (!item.customValidator && !item.key)) {
                isKeyError = true;
                isError = true;
            }
            if (isKeyError) {
                errorOb = {
                    ...errorOb,
                    ...getErrorWithType({
                        type: item.type,
                        extras: {
                            ...(item.customValidator && { errorMessage: item.getErrorMessage() })
                        }
                    })
                };
            }
        });
        setError(errorOb);
        if (!isError) {
            const payload = {
                make_id: selectedBrand.value,
                model_id: selectedModel.value,
                year_id: selectedYear.value,
                variant_id: selectedVariant.value,
                state_id: selectedState.value,
                phone: mobile.toString()
            };
            const query = {
                source: leadSource
            };
            let apiToCall = makeLeadConnect;
            if (token) {
                apiToCall = updateLeadConnect;
                query.token = token;
            }
            setIsLoading(true);
            apiToCall(query, payload).then((response) => {
                setIsLoading(false);
                history.push(`/appointment/index?token=${response.token}`);
            }).catch(() => {
                setIsLoading(false);
            });
        }
    };

    return (

        <div className={"d-flex flex-row"} styleName={"styles.formOuter"}>
            <div styleName={"styles.fieldWrap styles.radiusFirst"}>
                <Search
                    key={brandRemountValue}
                    onMenuClose={() => updateRemountedValues({
                        value: brandRemountValue,
                        fn: setBrandRemountValue
                    })}
                    customDefaultValue={getTranslatedValue({
                        identifier: selectedBrand,
                        key: "label",
                        defaultValue: null
                    })}
                    value={selectedBrand || undefined}
                    onChange={onBrandSelection}
                    data={getSelectOptions(
                        brands,
                        "make_display",
                        "make_id"
                    )}
                    noOptionsMessage={() => <span>No Brands Available</span>}
                    placeholder="Brands" />
                <div styleName={"styles.error"}>
                    <ErrorStrip err={error} type={ERR_TYPES.BRAND} />
                </div>
            </div>
            <div styleName={"styles.fieldWrap"}>
                <Search
                    key={modelRemountValue}
                    onMenuClose={() => updateRemountedValues({
                        value: modelRemountValue,
                        fn: setModelRemountValue
                    })}
                    customDefaultValue={getTranslatedValue({
                        identifier: selectedModel,
                        key: "label",
                        defaultValue: null
                    })}
                    value={selectedModel || undefined}
                    onChange={onModelSelection}
                    data={getSelectOptions(
                        models,
                        "model_display",
                        "model_id"
                    )}
                    noOptionsMessage={() => <span>No Models Available</span>}
                    placeholder="Models" />
                <div styleName={"styles.error"}>
                    <ErrorStrip err={error} type={ERR_TYPES.MODEL} />
                </div>
            </div>
            <div styleName={"styles.fieldWrap"}>
                <Search
                    key={yearRemountValue}
                    onMenuClose={() => updateRemountedValues({
                        value: yearRemountValue,
                        fn: setYearRemountValue
                    })}
                    customDefaultValue={getTranslatedValue({
                        identifier: selectedYear,
                        key: "label",
                        defaultValue: null
                    })}
                    value={selectedYear || undefined}
                    onChange={onYearSelection}
                    data={getSelectOptions(
                        years,
                        "year",
                        "year_id"
                    )}
                    noOptionsMessage={() => <span>No Years Available</span>}
                    placeholder="Year" />
                <div styleName={"styles.error"}>
                    <ErrorStrip err={error} type={ERR_TYPES.YEAR} />
                </div>
            </div>
            <div styleName={"styles.fieldWrap"}>
                <Search
                    key={variantRemountValue}
                    onMenuClose={() => updateRemountedValues({
                        value: variantRemountValue,
                        fn: setVariantRemountValue
                    })}
                    customDefaultValue={getTranslatedValue({
                        identifier: selectedVariant,
                        key: "label",
                        defaultValue: null
                    })}
                    value={selectedVariant || undefined}
                    onChange={onVariantSelection}
                    data={getSelectOptions(
                        variants,
                        "variant_display_name",
                        "variant_id"
                    )}
                    noOptionsMessage={() => <span>No Variants Available</span>}
                    placeholder="Variants" />
                <div styleName={"styles.error"}>
                    <ErrorStrip err={error} type={ERR_TYPES.VARIANT} />
                </div>
            </div>
            <div styleName={"styles.fieldWrap"}>
                <Search
                    key={stateRemountValue}
                    onMenuClose={() => updateRemountedValues({
                        value: stateRemountValue,
                        fn: setStateRemountValue
                    })}
                    customDefaultValue={getTranslatedValue({
                        identifier: selectedState,
                        key: "label",
                        defaultValue: null
                    })}
                    value={selectedState || undefined}
                    onChange={onStateSelection}
                    data={getSelectOptions(
                        states,
                        "displayText",
                        "state_id"
                    )}
                    noOptionsMessage={() => <span>No States Available</span>}
                    placeholder="State" />
                <div styleName={"styles.error"}>
                    <ErrorStrip err={error} type={ERR_TYPES.STATE} />
                </div>
            </div>
            <div styleName={"styles.fieldWrap"}>
                <InputMobile
                    showError = {false}
                    onChange={(e) => setMobileConnect(e.target.value)}
                    value={mobile}
                    placeholder="Mobile Number" />
                <div styleName={"styles.error"}>
                    <ErrorStrip err={error} type={ERR_TYPES.MOBILE} />
                </div>
            </div>
            <Button
                onClick={onSubmit}
                isLoading={isLoading}
                text="GET PRICE" />
        </div>

    );
};

LegacyForm.propTypes = {
    history: PropTypes.object,
    token: PropTypes.string,
    mobile: PropTypes.number,
    brands: PropTypes.array,
    models: PropTypes.array,
    years: PropTypes.array,
    variants: PropTypes.array,
    states: PropTypes.array,
    selectedBrand: PropTypes.object,
    selectedModel: PropTypes.object,
    selectedYear: PropTypes.object,
    selectedVariant: PropTypes.object,
    selectedState: PropTypes.object,
    lastUpdatedBrand: PropTypes.number,
    lastUpdatedModel: PropTypes.number,
    lastUpdatedYear: PropTypes.number,
    fetchBrandsConnect: PropTypes.func,
    fetchModelsConnect: PropTypes.func,
    fetchYearsConnect: PropTypes.func,
    fetchVariantsConnect: PropTypes.func,
    fetchRegistrationStateConnect: PropTypes.func,
    updateSelectedBrandConnect: PropTypes.func,
    updateSelectedModelConnect: PropTypes.func,
    updateSelectedYearConnect: PropTypes.func,
    updateSelectedVariantConnect: PropTypes.func,
    updateSelectedStateConnect: PropTypes.func,
    setMobileConnect: PropTypes.func,
    updateLeadConnect: PropTypes.func,
    makeLeadConnect: PropTypes.func,
    formHeading: PropTypes.string,
    leadSource: PropTypes.string
};

ErrorStrip.propTypes = {
    type: PropTypes.string,
    err: PropTypes.object
};

export default LegacyForm;
